

// Link thor to the AVIV consent service  
async function manageConsentForThor() {
  const isConsentGranted = await window?.__AVIV_CSNT__?.getIsConsentGranted() ?? false;
  if (isConsentGranted) {
    thor.onConsent();
  }
}
const consentSdk = window?.__AVIV_CSNT__;

if (!consentSdk?.createConsentService) {
  console.error("Failed to initialize consent service: consent SDK is not loaded");
} else {
  consentSdk
      .createConsentService("5kYOCoQ5YsSoa9", {
        onBannerInteraction(event, service) {
          manageConsentForThor();
        }
      })
      .then(() => {
        manageConsentForThor();
      })
      .catch((error) => {
        console.error("Failed to initialize consent service", error);
      });
}